@let disabled = disabled$ | async;
<app-control-wrapper
  [control]="control"
  [officeField]="officeField"
  [formGroupInstance]="formGroupInstance"
  [errorsMessagesOverridesRegistry]="errorsMessagesOverridesRegistry"
  [required]="control | controlHasRequired"
  [validating]="validating$()"
  [alignment]="alignment"
  [disabled]="disabled"
  [config]="config">
  <ng-container [ngSwitch]="type">
    <ng-container *ngSwitchCase="InputTypeEnum.percent">
      <app-input-percent
        [class]="'form-control'"
        [placeholder]="officeField?.InputMask || ''"
        [formControl]="control"
        [name]="officeField.VistaFormItem.ColumnName"
        [controlName]="officeField.Seq"
        [maxlength]="inputMaskConfig?.inputLength || officeField.InputLength"
        (blur)="onBlur($event)"
        [inputMaskConfig]="inputMaskConfig"
        [inputTransformFn]="inputTransformFn"></app-input-percent>
    </ng-container>
    <ng-container *ngSwitchCase="InputTypeEnum.textarea">
      <textarea
        #inputRef
        class="form-control"
        [name]="officeField.VistaFormItem.ColumnName"
        [formControl]="control"
        [maxlength]="officeField.InputLength"
        (blur)="onBlur($event)"></textarea>
    </ng-container>
    <ng-container *ngSwitchDefault>
      <input
        #inputRef
        type="text"
        class="form-control"
        [placeholder]="officeField?.InputMask || ''"
        [mask]="inputMaskConfig?.pattern || null"
        [specialCharacters]="inputMaskConfig?.specialCharacters || []"
        [formControl]="control"
        [name]="officeField.VistaFormItem.ColumnName"
        [maxlength]="inputMaskConfig?.inputLength || officeField.InputLength"
        (blur)="onBlur($event)"
        [thousandSeparator]="inputMaskConfig?.thousandSeparator || ''"
        [suffix]="inputMaskConfig?.suffix || ''"
        [prefix]="inputMaskConfig?.prefix || ''"
        [leadZero]="inputMaskConfig?.leadZero || null"
        [decimalMarker]="inputMaskConfig?.decimalMarker || null"
        [dropSpecialCharacters]="inputMaskConfig?.dropSpecialCharacters || false"
        [allowNegativeNumbers]="inputMaskConfig?.allowNegativeNumbers || null"
        [inputTransformFn]="inputTransformFn"
    /></ng-container>
  </ng-container>
</app-control-wrapper>
